import { CopyButton } from '@/components/ui/copy-button'

export function IdentifierRow({
  label,
  value,
}: {
  label: string
  value: string
}) {
  return (
    <div className="flex items-center justify-between gap-4 py-1.5 text-sm">
      <dt className="text-muted-foreground min-w-0 shrink truncate">{label}</dt>
      <dd className="flex min-w-0 items-center gap-2">
        <span className="min-w-0 truncate font-mono text-xs">{value}</span>
        <CopyButton
          content={value}
          label={`Copy ${label}`}
          className="text-neutral-hover-border hover:text-primary-solid shrink-0"
        />
      </dd>
    </div>
  )
}
